// lib
import View from 'ln/view/View';
import Node from 'ln/node/Node';
import ListRenderer from "ln/list/ListRenderer";
import ModifiableList from "ln/list/ModifiableList";
import Template from "ln/template/TemplateManager";

// project
import SearchFilterView from './SearchFilterView';
import TagFilterView from './TagFilterView';
import CourseModel from '../../course/models/CourseModel';
import UserCourseModel from '../../course/models/UserCourseModel';

interface IComparisonAttributes{
	tagFilterAttributes: Array<string>;
	searchFilterAttributes: Array<string>;
}


class BaseCourseListFilterView extends View {

	protected courseListRenderer:ListRenderer<CourseModel|UserCourseModel>;
	protected courseList: ModifiableList<CourseModel|UserCourseModel>;
	protected comparisonAttributes

	public constructor( courses:Array<CourseModel|UserCourseModel>, comparisonAttributes:IComparisonAttributes ) {
		super();

		this.courseList = new ModifiableList<CourseModel|UserCourseModel>( courses );
		this.comparisonAttributes = comparisonAttributes;

		this.defaultTemplate = 'krw.courselistfilter';
	}

    public init() {		
		this.renderCourses();
		this.renderFilter();
	}
		
	protected renderCourses() {

		this.courseListRenderer = new ListRenderer<CourseModel|UserCourseModel>( this.node.one('.list') );
		this.courseListRenderer.selectorFunction = function( item:any ) {
			return item.modelName;
		}
	}
	
	renderFilter() {
		// render search filter
		if( this.comparisonAttributes.searchFilterAttributes.length > 0 ){
			var searchFilterView = new SearchFilterView( this.courseList );
			searchFilterView.comparisonAttributes = this.comparisonAttributes.searchFilterAttributes;
			searchFilterView.render();
			this.node.one( '.filter-bar' ).append( searchFilterView.node );
			
			// enhanced search button
			searchFilterView.node.one( 'a' ).click.add( function() {
				this.node.one( '.filters' ).toggleClass( 'collapsed' );
			}, this);
		}
		
		// render tag filter
		if( this.comparisonAttributes.tagFilterAttributes.length > 0 ){
			this.comparisonAttributes.tagFilterAttributes.forEach( key => {
				var tagFilterView = new TagFilterView( this.courseList );
				tagFilterView.comparisonAttribute = key;
				tagFilterView.title = 'library.filter.' + key;
				tagFilterView.render();
				this.node.one( '.filters' ).append( tagFilterView.node );			
			});
		}
		
	};

	/**
	 * Show the delete dialog
	 */
	protected showDialog( course:UserCourseModel, okHandler:( course:UserCourseModel ) => void, dialogKey:string ) {
		
		var dialog = Node.fromHTML( Template.render( 'krw.dialog', { title: dialogKey } ) );
		var dialogNode = this.node.one( '.dialog-container' );

		dialog.one( '.ok' ).click.add( () => {
			okHandler( course );
			dialogNode.removeChild( dialog );
			dialogNode.addClass( 'hidden' );
		});

		dialog.one( '.abort' ).click.add( () => {
			dialogNode.removeChild( dialog );
			dialogNode.addClass( 'hidden' );
		});

		dialogNode.append( dialog );
		dialogNode.removeClass( 'hidden' );

	}

}

export default BaseCourseListFilterView;